import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";

const ShopContext = createContext(null);

export function ShopProvider({ children }) {
    const { user } = useAuth();
    const [cartCount, setCartCount] = useState(0);
    const [aiOpen, setAiOpen] = useState(false);
    const [unread, setUnread] = useState(0);
    const [compareIds, setCompareIds] = useState(() => {
        try {
            return JSON.parse(localStorage.getItem("ata_compare") || "[]");
        } catch {
            return [];
        }
    });

    const refreshCart = useCallback(async () => {
        if (!user) return;
        try {
            const r = await api.get("/cart");
            const count = (r.data.groups || []).reduce((acc, g) => acc + g.items.length, 0);
            setCartCount(count);
        } catch {
            /* sessiz */
        }
    }, [user]);

    const refreshNotifications = useCallback(async () => {
        if (!user) return;
        try {
            const r = await api.get("/notifications");
            setUnread(r.data.unread || 0);
        } catch {
            /* sessiz */
        }
    }, [user]);

    useEffect(() => {
        refreshCart();
        refreshNotifications();
    }, [refreshCart, refreshNotifications]);

    const toggleCompare = (productId) => {
        setCompareIds((prev) => {
            const next = prev.includes(productId) ? prev.filter((x) => x !== productId) : [...prev, productId].slice(-6);
            localStorage.setItem("ata_compare", JSON.stringify(next));
            return next;
        });
    };

    const clearCompare = () => {
        localStorage.removeItem("ata_compare");
        setCompareIds([]);
    };

    return (
        <ShopContext.Provider
            value={{ cartCount, refreshCart, aiOpen, setAiOpen, unread, refreshNotifications, compareIds, toggleCompare, clearCompare }}
        >
            {children}
        </ShopContext.Provider>
    );
}

export const useShop = () => useContext(ShopContext);
